<div class="panorama-container">
    <div *ngIf="!play" (click)="play = true" class="panorama-container-button">
        Открыть панораму
    </div>
    <div (click)="close.emit()" class="panorama-container-cross" [class]="play ? 'panorama-container-cross-white' : 'panorama-container-cross-red'">
        <app-icon [icon]="play ? Icons.cross : Icons.crossWhite"/>
    </div>
    <div *ngIf="play" class="panorama">
        <iframe *ngIf="panoramaKey == 'most'" src="https://s3.ru1.storage.beget.cloud/7073a12603cc-szdmap/panorama/most/index.html" width="100%" height="100%"></iframe>
        <iframe *ngIf="panoramaKey == 'moskovskiy'" src="https://s3.ru1.storage.beget.cloud/7073a12603cc-szdmap/panorama/moskovskiy/index.html" width="100%" height="100%"></iframe>
        <iframe *ngIf="panoramaKey == 'vspolie'" src="https://s3.ru1.storage.beget.cloud/7073a12603cc-szdmap/panorama/vspolie/index.html" width="100%" height="100%"></iframe>
        <iframe *ngIf="panoramaKey == 'bui'" src="https://s3.ru1.storage.beget.cloud/7073a12603cc-szdmap/panorama/bui/index.html" width="100%" height="100%"></iframe>
        <iframe *ngIf="panoramaKey == 'vologda'" src="https://s3.ru1.storage.beget.cloud/7073a12603cc-szdmap/panorama/vologda/index.html" width="100%" height="100%"></iframe>
        <iframe *ngIf="panoramaKey == 'cherepovec'" src="https://s3.ru1.storage.beget.cloud/7073a12603cc-szdmap/panorama/cherepovec/index.html" width="100%" height="100%"></iframe>
    </div>
</div>

